import getBasePath from '../functions/api-resource';
import genericActions from './generic-resource';
import empresa from '../functions/company';

const basePath = getBasePath('api', 'v1');

const clienteActions = {
    ...genericActions(basePath),
    logIn: { method: 'POST', url: `${basePath}/clienteSTShop/login?conexion=${empresa}` },
    empresa: { method: 'GET', url: `${basePath}/clienteSTShop/company?conexion=${empresa}` },
    RecuperaPass: { method: 'POST', url: `${basePath}/clienteSTShop/recupera?conexion=${empresa}` },
    RecuperaUsuario: { method: 'POST', url: `${basePath}/clientes/recuperarUsuario` },
    changePassword: { method: 'PUT', url: `${basePath}/clienteSTShop/cambiarContrasena/{idcliente}?conexion=${empresa}` },
    changeRegimen: { method: 'PUT', url: `${basePath}/clientes/cambiarRegimen/{idcliente}?conexion=${empresa}` },
    crear: { method: 'POST', url: `${basePath}/clienteSTShop?conexion=${empresa}` },
    postDireccion: { method: 'POST', url: `${basePath}/clientes/{idCliente}/direcciones?conexion=${empresa}` },
    getDireccion: { method: 'GET', url: `${basePath}/clientes/{idCliente}/direcciones?conexion=${empresa}` },
    getRegimenFiscal: { method: 'GET', url: `${basePath}/clientes/Regimen` },
    getUsoCFDI: { method: 'GET', url: `${basePath}/clientes/UsoCFDI` },

    parametros: { method: 'GET', url: `${basePath}/parametrosStshop?conexion=${empresa}` },
    validacion: { method: 'GET', url: `${basePath}/personal/validacionStshop?conexion=${empresa}` },

};

export default resource => resource(`${basePath}`, {}, clienteActions);


// WEBPACK FOOTER //
// ./src/common/resources/cliente.js